module.exports = __webpack_public_path__ + "img/70000.1d4dcdae.svg";